module.exports = __webpack_public_path__ + "img/dashboard-white.1d543a2f.svg";